import React from 'react';
import Status from './Status';
import useCheckboxes from '../../hooks/useCheckboxes';
import {I18N} from '../../globals/config';

import styles from './items.pcss';

type Props = {}

const Items = ( {}: Props ) => {
	const {checkCheckbox, checkboxes, updating, isSections, hasChecked} = useCheckboxes();
	return (
		<div className={styles.wrap}>
			<div className={styles.header}>
				<div className={styles.checkbox}>
					&nbsp;
				</div>
				<div className={styles.label}>
					{isSections ? I18N.sections : I18N.tables}
				</div>
				{hasChecked && <div className={styles.status}>
					{I18N.status}
				</div>}
			</div>

			{Object.keys( checkboxes ).map( table =>
				<div className={styles.row} key={table}>
					<div className={styles.checkbox}>
						<input
							type="checkbox"
							disabled={updating}
							value={table}
							onChange={ev => {
								checkCheckbox( table, ev.target?.checked );
							}}
							checked={checkboxes[ table ].checked} />
					</div>
					<div className={styles.label}>
						{checkboxes[ table ].label}
					</div>
					<div className={styles.status}>
						<Status {...checkboxes[ table ]} />
					</div>
				</div>,
			)}
		</div>
	);
};

export default Items;
